import "./style.css";

import { ScrollBehavior } from "../../lib";

new ScrollBehavior({ elementSelector: ".section" });
